import React from 'react';
import MainPanel from '../../components/layout/MainPanel';
import { useDashboardData } from '../../components/DashboardShell';
import { useLocale } from '../../context/LocaleContext';

export default function LiveChatPage() {
  const { data } = useDashboardData();
  const { t } = useLocale();
  const all = data?.campaigns || [];
  const live = all.filter((c) => (c.campaignType || '').toLowerCase() === 'live_chat');

  return (
    <MainPanel
      title={t('liveChat.title')}
      actions={
        <button type="button" className="custio-btn-primary" style={{ borderRadius: 999 }}>
          {t('campaigns.create')}
        </button>
      }
    >
      {live.length === 0 ? (
        <div className="custio-empty" style={{ paddingTop: 24 }}>
          <p className="custio-empty__title">{t('liveChat.emptyTitle')}</p>
          <p style={{ fontSize: 14, margin: 0, color: '#9ca3af' }}>
            {t('liveChat.emptyIntro')}{' '}
            <code style={{ color: '#a5b4fc' }}>live_chat</code> {t('liveChat.emptyOutro')}
          </p>
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
          {live.map((c) => (
            <div
              key={c.id}
              style={{
                background: '#1f2229',
                borderRadius: 16,
                padding: 20,
                color: '#f3f4f6',
                border: '1px solid rgba(255,255,255,0.08)',
              }}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                  <strong>{c.name}</strong>
                  <span
                    style={{
                      background: c.enabled ? '#166534' : '#44403c',
                      color: c.enabled ? '#bbf7d0' : '#d6d3d1',
                      fontSize: 11,
                      fontWeight: 600,
                      padding: '4px 10px',
                      borderRadius: 999,
                    }}
                  >
                    {c.enabled ? t('common.enabled') : t('common.disabled')}
                  </span>
                </div>
              </div>
              <p style={{ color: '#9ca3af', margin: '0 0 12px' }}>{c.messageBody}</p>
              <p style={{ fontSize: 12, color: '#6b7280', margin: 0 }}>{t('liveChat.footer')}</p>
            </div>
          ))}
        </div>
      )}
    </MainPanel>
  );
}
